(function($){
    "use strict";
    $(document).ready(function(){
        // if iFrame then hide header
        if (0 !== window.top.frames.length) {
            document.getElementById('header').style.display = 'none';
        }
    });
})(jQuery);